import { render, staticRenderFns } from "./DialogProducts.vue?vue&type=template&id=38e2ab7d&scoped=true"
import script from "./DialogProducts.vue?vue&type=script&lang=js"
export * from "./DialogProducts.vue?vue&type=script&lang=js"
import style0 from "./DialogProducts.vue?vue&type=style&index=0&id=38e2ab7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2ab7d",
  null
  
)

export default component.exports